import { MobileRowLayout } from "src/components/organisms/ColumnTemplatePositionEditor/types";
import { TableCellValue } from "src/requests/table/types";
import { EditRowWithColumns } from "src/requests/tableRowActions/types";
import { ColumnFormatDict } from "src/requests/templates/types";

export type FlowioTableRow = EditRowWithColumns | null;

export interface CreateRowURLData {
  templateId: number;
  rowIdToCopy: number | null;
  overviewId: number | null;
}

export type TableRowCreateMatchParams = {
  templateId: string;
};

export type TableRowFormat = {
  columnFormat: ColumnFormatDict;
  rowLayout: MobileRowLayout | undefined;
};

export type OnInputChange = (colKey: string, value: TableCellValue) => void;

export enum TableRowCreateQueryParams {
  overviewId = "overviewId",
  rowIdToCopy = "rowIdToCopy",
}
